"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MenuButton = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _MoreVert = _interopRequireDefault(require("@material-ui/icons/MoreVert"));

var _Button = _interopRequireDefault(require("../Button"));

var _Menu = _interopRequireDefault(require("../Menu"));

var MenuButton = function MenuButton(_ref) {
  var id = _ref.id,
      children = _ref.children,
      icon = _ref.icon,
      light = _ref.light;

  var _React$useState = _react["default"].useState(null),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var onMenuButtonClick = function onMenuButtonClick(e) {
    if (e) {
      e.stopPropagation();
      setAnchorEl(e.currentTarget);
    }
  };

  var onMenuClose = function onMenuClose(e) {
    if (e) {
      e.stopPropagation();
    }

    setAnchorEl(null);
  };

  var prepareChild = function prepareChild(child) {
    return _react["default"].cloneElement(child, {
      onClick: function onClick(e) {
        if (e) {
          e.stopPropagation();
        }

        onMenuClose();

        if (child.props.onClick) {
          child.props.onClick();
        }
      }
    });
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: id,
    icon: true,
    flat: true,
    licorice: !light,
    vanilla: light,
    onClick: onMenuButtonClick
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true
  }, icon)), /*#__PURE__*/_react["default"].createElement(_Menu["default"], {
    id: "menu-button-menu-".concat(id),
    anchorEl: anchorEl,
    open: !!anchorEl,
    onClose: onMenuClose
  }, _react["default"].Children.toArray(children).map(prepareChild)));
};

exports.MenuButton = MenuButton;
MenuButton.defaultProps = {
  children: null,
  icon: [/*#__PURE__*/_react["default"].createElement(_MoreVert["default"], {
    key: "more-vertical-icon"
  })],
  light: false
};
var _default = MenuButton;
exports["default"] = _default;